export default "__VITE_PUBLIC_ASSET__e18c7f84__"